var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 6C5.13401 6 2 9.13401 2 13C2 16.866 5.13401 20 9 20C12.866 20 16 16.866 16 13C16 9.13401 12.866 6 9 6ZM0 13C0 8.02944 4.02944 4 9 4C13.9706 4 18 8.02944 18 13C18 17.9706 13.9706 22 9 22C4.02944 22 0 17.9706 0 13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1C6 0.447715 6.44772 0 7 0H11C11.5523 0 12 0.447715 12 1C12 1.55228 11.5523 2 11 2H10V5C10 5.55228 9.55228 6 9 6C8.44772 6 8 5.55228 8 5V2H7C6.44772 2 6 1.55228 6 1ZM16.7071 4.79289C17.0976 5.18342 17.0976 5.81658 16.7071 6.20711L15.2071 7.70711C14.8166 8.09763 14.1834 8.09763 13.7929 7.70711C13.4024 7.31658 13.4024 6.68342 13.7929 6.29289L15.2929 4.79289C15.6834 4.40237 16.3166 4.40237 16.7071 4.79289ZM9 9C9.55228 9 10 9.44771 10 10V13C10 13.5523 9.55228 14 9 14H6C5.44772 14 5 13.5523 5 13C5 12.4477 5.44772 12 6 12H8V10C8 9.44771 8.44772 9 9 9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerIcon);
export default __webpack_public_path__ + "static/media/TimerIcon.9f2beb4aef9493ab3c742f33cb668913.svg";
export { ForwardRef as ReactComponent };